import Vue from "vue";
import {
    carouselComponentComputed,
    carouselComponentData,
    carouselComponentDefinition,
    carouselComponentMethods,
} from "./carousel";

let widgets = document.querySelectorAll('[data-trustpilot-carousel]');
if( widgets && widgets.length ) {
    widgets.forEach( widget => {
        let component = new Vue({
            ...carouselComponentDefinition,
            el: widget,
            computed: {
                // We need to do this, otherwise each carousel shares the same 'computed' object,
                // as the component definition is only shallow copied.
                ...carouselComponentComputed
            },
            data: {
                // We need to do this, otherwise each carousel shares the same 'data' object,
                // as the component definition is only shallow copied.
                ...carouselComponentData,
                label : 'trustpilot'
            },
        });
    });
}
